var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowOfferCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.354 4.354a.5.5 0 000-.708L22.172.464a.5.5 0 10-.707.708L24.293 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM0 4.5h25v-1H0v1z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDI2IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNS4zNTM2IDQuMzUzNTZDMjUuNTQ4OCA0LjE1ODI5IDI1LjU0ODggMy44NDE3MSAyNS4zNTM2IDMuNjQ2NDVMMjIuMTcxNiAwLjQ2NDQ2OEMyMS45NzYzIDAuMjY5MjA2IDIxLjY1OTcgMC4yNjkyMDYgMjEuNDY0NSAwLjQ2NDQ2OEMyMS4yNjkyIDAuNjU5NzMgMjEuMjY5MiAwLjk3NjMxMyAyMS40NjQ1IDEuMTcxNTdMMjQuMjkyOSA0TDIxLjQ2NDUgNi44Mjg0M0MyMS4yNjkyIDcuMDIzNjkgMjEuMjY5MiA3LjM0MDI3IDIxLjQ2NDUgNy41MzU1NEMyMS42NTk3IDcuNzMwOCAyMS45NzYzIDcuNzMwOCAyMi4xNzE2IDcuNTM1NTRMMjUuMzUzNiA0LjM1MzU2Wk0tNC4zNzExNGUtMDggNC41TDI1IDQuNUwyNSAzLjVMNC4zNzExNGUtMDggMy41TC00LjM3MTE0ZS0wOCA0LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowOfferCard as ReactComponent };